import React, { useState } from "react";
import { ActionMenu } from "../../Components/ActionMenu";
import { Button } from "../../Components/Button";
import { StackedButtons, LeftButtons, RightButtons } from "./ToolbarStyles";
import { sanitiseString } from "../../Utils/StringUtils";

export interface Props {
  id: string;
  dataTestId: string;
  leftButtons?: (ReturnType<typeof ActionMenu> | ReturnType<typeof Button>)[];
  rightButtons?: (ReturnType<typeof ActionMenu> | ReturnType<typeof Button>)[];
  collapsibleLabel: string;
  collapsibleAriaLabel: string;
}

export const Toolbar = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const sanitisedId: string = sanitiseString(props.id);
  const sanitisedDataTestId: string = sanitiseString(props.dataTestId);

  return (
    <div data-testid={sanitisedDataTestId}>
      <div className="ons-navigation ons-navigation--sub ons-u-d-no@xxs@l">
        <div className="ons-container ons-container--wide">
          <div className="ons-grid--flex ons-grid--between">
            <div className="ons-grid--flex">{props.leftButtons}</div>
            <div className="ons-grid--flex">{props.rightButtons}</div>
          </div>
        </div>
      </div>
      <div className="ons-u-d-no@l">
        <Button
          id={`${sanitisedId}-stacked-nav-toggle`}
          text={props.collapsibleLabel}
          classes={`ons-js-sub-navigation-button ons-u-d-no@l ons-btn--mobile ons-btn--dropdown ${isOpen && "active"}`}
          iconType="ArrowIcon"
          iconPosition="after"
          onClick={() => setIsOpen(!isOpen)}
          ariaLabel={props.collapsibleAriaLabel}
          ariaControls="sub-nav"
          ariaExpanded={isOpen}
          dataTestId={`${sanitisedDataTestId}-stacked-nav-toggle`}
        />

        {isOpen && (
          <StackedButtons data-testid={`${sanitisedDataTestId}-stacked-nav`}>
            <LeftButtons>{props.leftButtons}</LeftButtons>
            <RightButtons>{props.rightButtons}</RightButtons>
          </StackedButtons>
        )}
      </div>
    </div>
  );
};
